import { render, staticRenderFns } from "./ItemExtraInfoLayout.vue?vue&type=template&id=b5ba5e2e&scoped=true"
import script from "./ItemExtraInfoLayout.vue?vue&type=script&lang=js"
export * from "./ItemExtraInfoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ba5e2e",
  null
  
)

export default component.exports